export type Enum<T> = Record<string, T>

export const isEnumValue = <T>(
  enumSelf: Enum<T>,
  value: unknown,
): value is T => {
  return (Object.values(enumSelf) as any).includes(value)
}
